





























































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app';
import NavigationScope from '@/models/Shared/NavigationMenu';
import Alert from '@/components/Shared/Alert.vue';
import UserType from '@/models/Users/UserType';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'AgencyPicker', components: { Alert }
})
export default class extends GiganautVue {

    created() {
        AppModule.getAgencyContext(AppModule.userProfile.agencyIdentifiers[0].id);
    }

    get agencies() {
            return AppModule.userProfile.agencyIdentifiers;
    }

    agencyClicked(index: number) {
        AppModule.getAgencyContext(AppModule.userProfile.agencyIdentifiers[index].id);
    }

    returnClicked(index: number) {
        this.$router.push({ name: PageNames.Login });  
    }

    async continueClicked() {
        await AppModule.getAgencyContext(AppModule.currentAgencyContext.id)
        await AppModule.getUserProfile()
        switch (AppModule.userProfile.userType) {
            // case UserType.Company: {
            //     //Every company has a permission to read the company record which contains the company ID
            //     var companyID;
            //     AppModule.userProfile.permissions.forEach(permission => {
            //         console.log(AppModule.userProfile.permissions)
            //     if (permission.entityType === "Company" && permission.permission === "Company_Profile_Read") {
            //         companyID = permission.entityId;
            //     }});
            //     this.$router.push({ name: PageNames.CompanyBookings, params: { companyid: companyID } });
            //     break;
            // }
            case UserType.Worker: {
                this.$router.push({ name: 'WorkerSchedule'});
                break;
            }
        }
    }
}
